/**
 * Cover image with allowlisted hosts. The Worker's CSP also restricts
 * `img-src` to these hosts; this component is the front-line filter so we
 * don't even attempt loads from arbitrary URLs returned by external APIs.
 */
const ALLOWED_HOSTS = ["covers.openlibrary.org", "image.tmdb.org"];

function isSafeUrl(url: string | null): url is string {
  if (!url) return false;
  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:" && ALLOWED_HOSTS.includes(parsed.hostname);
  } catch {
    return false;
  }
}

export function SafeCover({
  url,
  alt,
  className,
}: {
  url: string | null;
  alt: string;
  className?: string;
}) {
  if (!isSafeUrl(url)) {
    return (
      <div
        className={`bg-gray-700 flex items-center justify-center text-xs text-gray-400 ${className ?? ""}`}
        aria-label="No cover"
      >
        No cover
      </div>
    );
  }
  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      className={`object-cover ${className ?? ""}`}
    />
  );
}
